import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal
} from "@azure/msal-react";
import {
  Body1,
  Button,
  Card,
  CardHeader,
  Caption1,
  makeStyles,
  tokens
} from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { authConfig } from "../model/auth";
import { Activaton } from "./Activation";
import { AppShell } from "./layout/AppShell";
import { Manage } from "./Manage";

const useStyles = makeStyles({
  stack: {
    display: "grid",
    gap: tokens.spacingVerticalXXL,
  },
  hero: {
    display: "grid",
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingVerticalXXL,
  },
  heroText: {
    display: "grid",
    gap: tokens.spacingVerticalM,
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacingHorizontalM,
  },
});

export const Content: React.FC = () => {
  const { instance } = useMsal();
  const [marketplaceToken, setMarketplaceToken] = useState<string | null>(null);
  const styles = useStyles();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setMarketplaceToken(params.get("token"));
  }, []);

  return (
    <AppShell>
      <AuthenticatedTemplate>
        <div className={styles.stack}>
          {marketplaceToken ? (
            <Activaton marketplaceToken={marketplaceToken} onActivationSucceeded={() => setMarketplaceToken(null)} />
          ) : (
            <Manage />
          )}
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Card appearance="filled-alternative" className={styles.hero}>
          <CardHeader
            header={<Body1><strong>Mailmaister for Microsoft 365</strong></Body1>}
            description={
              <Caption1>
                Sign in to continue.
              </Caption1>
            }
          />
          <div className={styles.heroText}>
            <Body1>
              Manage subscription activation, admin consent, users, and subscription details.
            </Body1>
            <Caption1>
              {marketplaceToken
                ? "Your Marketplace token is ready. Sign in to continue the activation flow."
                : "Sign in with a Microsoft account to view subscription details and manage tenant seats."}
            </Caption1>
          </div>
          <div className={styles.actions}>
            <Button appearance="primary" onClick={() => instance.loginRedirect(authConfig)}>
              Sign in with Microsoft
            </Button>
          </div>
        </Card>
      </UnauthenticatedTemplate>
    </AppShell>
  );
};
